export default __webpack_public_path__ + "static/media/SWAMP.4c8cbfbb.svg";